import {
  collection,
  deleteDoc,
  doc,
  getDocs,
  writeBatch,
} from "firebase/firestore";

import db from "../FirestoreConfig";
import {
  buildClientNutritionPlanMealsCollectionPath,
  buildClientNutritionPlansCollectionPath,
  buildClientNutritionRootDocPath,
} from "./nutritionPaths";

const normalizeClientId = (value) => String(value ?? "").trim();

export async function deleteActiveClientNutritionData({
  clientId,
  database = db,
} = {}) {
  const normalizedClientId = normalizeClientId(clientId);
  if (!normalizedClientId) {
    return {
      deletedPlanCount: 0,
      deletedMealCount: 0,
      deletedRootDoc: false,
    };
  }

  const plansCollectionRef = collection(
    database,
    ...buildClientNutritionPlansCollectionPath(normalizedClientId),
  );
  const plansSnapshot = await getDocs(plansCollectionRef);

  let deletedPlanCount = 0;
  let deletedMealCount = 0;

  for (const planDoc of plansSnapshot.docs) {
    const mealsCollectionRef = collection(
      database,
      ...buildClientNutritionPlanMealsCollectionPath(normalizedClientId, planDoc.id),
    );
    const mealsSnapshot = await getDocs(mealsCollectionRef);
    const batch = writeBatch(database);

    mealsSnapshot.docs.forEach((mealDoc) => {
      batch.delete(mealDoc.ref);
      deletedMealCount += 1;
    });

    batch.delete(planDoc.ref);
    await batch.commit();
    deletedPlanCount += 1;
  }

  await deleteDoc(
    doc(database, ...buildClientNutritionRootDocPath(normalizedClientId)),
  );

  return {
    deletedPlanCount,
    deletedMealCount,
    deletedRootDoc: true,
  };
}
